import { UserRoleListItem } from '@entities/user/api/user-management-types';
import { UserRoles } from '@shared/model/user';

export const userRoleId = ({ items, role }: { items?: UserRoleListItem[]; role: UserRoles }) => {
    const roleItem = (items || []).find((item) => item.code === role);
    return roleItem?.id;
};
